import React from 'react';
import { Box, Flex, Text } from '@cko/primitives';
import { CloudUploadIcon } from '../assets';
import { DroppedRow } from './DroppedRow';
export const DroppedFilesSummary = ({ files, handleDelete, children }) => {
    if (!Object.keys(files).length) {
        return (React.createElement(Box, { borderBottom: "var(--border-b-seed) solid var(--base-border-secondary)", py: "var(--layout-spoon)", mx: "auto" },
            React.createElement(Flex, { justifyContent: "center", alignItems: "center" },
                React.createElement(CloudUploadIcon, null),
                React.createElement(Text, { font: "var(--body-sm-medium)", ml: "var(--layout-spoon)" }, "Drag and drop files here to upload"))));
    }
    return (React.createElement(React.Fragment, null, Object.entries(files).map(([id, { name, status, errors }]) => {
        return (React.createElement(DroppedRow, { key: id, id: id, name: name, status: status, errors: errors, handleDelete: handleDelete }, children));
    })));
};
